<template>
  <!-- Team Sponsors -->
  <section class="container">
    <div class="row justify-content-center">
      <div class="col col-lg-10">
        <h5 class="text-uppercase">Team Sponsors</h5>

        <div class="row justify-content-start">
          <!-- <div class="col-6 col-sm-4 col-md-2 my-3">
                        <a href="#"
                           class="box-link box-light box-link-grey has-hover-s1">
                            <figure class="p-3"><img src=""
                                                     class="img-fluid"
                                                     alt=""></figure>
                        </a>
                    </div> -->
          <div class="col-12">
            <a href="#" class="box-link box-light box-link-grey has-hover-s1">
              <figure>
                <img
                  src="../assets/img/logo-tf.svg"
                  class="img-fluid w-50"
                  alt=""
                />
              </figure>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
